/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerInsurance } from './ScreenerInsurance';
import {
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceFromJSONTyped,
    ScreenerInsuranceToJSON,
    ScreenerInsuranceToJSONTyped,
} from './ScreenerInsurance';

/**
 * 
 * @export
 * @interface UpdateLeadInsurances200Response
 */
export interface UpdateLeadInsurances200Response {
    /**
     * 
     */
    data?: Array<ScreenerInsurance>;
}

/**
 * Check if a given object implements the UpdateLeadInsurances200Response interface.
 */
export function instanceOfUpdateLeadInsurances200Response(value: object): value is UpdateLeadInsurances200Response {
    return true;
}

export function UpdateLeadInsurances200ResponseFromJSON(json: any): UpdateLeadInsurances200Response {
    return UpdateLeadInsurances200ResponseFromJSONTyped(json, false);
}

export function UpdateLeadInsurances200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadInsurances200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScreenerInsuranceFromJSON)),
    };
}

export function UpdateLeadInsurances200ResponseToJSON(json: any): UpdateLeadInsurances200Response {
    return UpdateLeadInsurances200ResponseToJSONTyped(json, false);
}

export function UpdateLeadInsurances200ResponseToJSONTyped(value?: UpdateLeadInsurances200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScreenerInsuranceToJSON)),
    };
}

